<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1">
<div id="u9ndIMtDMBILMerY9Ew8VsF">
<img alt="" class="_idGenObjectAttribute-1" src="image/MCidentity-cecilia1_b_w.png"/>
</div>
</div>
<div class="Basic-Text-Frame" id="u9pElzqvEwneeJZoJyevcqB">
<p class="Basic-Paragraph ParaOverride-4"><span class="Body CharOverride-4">Microcosm Publishing is Portland’s most diversified publishing house and distributor with a focus on the colorful, authentic, and empowering. Our books and zines have put your power in your hands since 1996, equipping readers to make positive changes in their lives and in the world around them. Microcosm emphasizes skill-building, showing hidden histories, and fostering creativity through challenging conventional publishing wisdom with books and bookettes about DIY skills, food, bicycling, gender, self-care, and social justice. What was once a distro and record label was started by Joe Biel in his bedroom and has become among the oldest independent publishing houses in Portland, OR. We are a politically moderate, centrist publisher in a world that has inched to the right for the past 80 years.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// stsebastianepub_split1.vue?26d6511e